import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink, Navigate, useParams, useNavigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth, GESTIONE_PAGES, GESTIONI_META } from "@/lib/AuthContext";
import { AnnoScolasticoProvider } from "@/lib/annoScolastico";
import { BUILD_TAG } from "@/lib/buildTag";
import Dashboard from "@/pages/Dashboard";
import AlunniPage from "@/pages/AlunniPage";
import ClassiPage from "@/pages/ClassiPage";
import VerificaAnagraficaPage from "@/pages/VerificaAnagraficaPage";
import MovimentiPage from "@/pages/MovimentiPage";
import PrenotazioniLibriPage from "@/pages/PrenotazioniLibriPage";
import ModuliAlunniPage from "@/pages/ModuliAlunniPage";
import DelegheRitiroPage from "@/pages/DelegheRitiroPage";
import FarmaciAlunniPage from "@/pages/FarmaciAlunniPage";
import FarmaciAnnualePage from "@/pages/FarmaciAnnualePage";
import DieteAlunniPage from "@/pages/DieteAlunniPage";
import IseeAlunniPage from "@/pages/IseeAlunniPage";
import RidAlunniPage from "@/pages/RidAlunniPage";
import DoteScuolaPage from "@/pages/DoteScuolaPage";
import CedolePage from "@/pages/CedolePage";
import ImpostazioniPage from "@/pages/ImpostazioniPage";
import UtentiPage from "@/pages/UtentiPage";
import ImportazioniPage from "@/pages/ImportazioniPage";
import TabellePage from "@/pages/TabellePage";
import ElaborazioneGiornoPage from "@/pages/ElaborazioneGiornoPage";
import ElaborazionePeriodoPage from "@/pages/ElaborazionePeriodoPage";
import ElaborazioneCassaPage from "@/pages/ElaborazioneCassaPage";
import ReportAddebitiPage from "@/pages/ReportAddebitiPage";
import PrimaNotaPage from "@/pages/PrimaNotaPage";
import PrimaNotaFatturePage from "@/pages/PrimaNotaFatturePage";
import PrimaNotaVociExtraPage from "@/pages/PrimaNotaVociExtraPage";
import PrimaNotaBilancioPage from "@/pages/PrimaNotaBilancioPage";
import PrimaNotaBilancioSchemaPage from "@/pages/PrimaNotaBilancioSchemaPage";
import PrimaNotaAnagraficaPage from "@/pages/PrimaNotaAnagraficaPage";
import PrimaNotaTabellePage from "@/pages/PrimaNotaTabellePage";
import PrimaNotaVerificaPage from "@/pages/PrimaNotaVerificaPage";
import ModuliPage from "@/pages/ModuliPage";
import StatiCassaPage from "@/pages/StatiCassaPage";
import BancaPage from "@/pages/BancaPage";
import DocentiPage from "@/pages/DocentiPage";
import DocentiSicurezzaPage from "@/pages/DocentiSicurezzaPage";
import DocenteEventiPage from "@/pages/DocenteEventiPage";
import MensaGiornoPage from "@/pages/MensaGiornoPage";
import MensaMatricePage from "@/pages/MensaMatricePage";
import FaqMensaPage from "@/pages/FaqMensaPage";
import MensaStoricoPage from "@/pages/MensaStoricoPage";
import MensaPresenzePage from "@/pages/MensaPresenzePage";
import RefettoriPage from "@/pages/RefettoriPage";
import ExtraCorsiPage from "@/pages/ExtraCorsiPage";
import ExtraIscrizioniPage from "@/pages/ExtraIscrizioniPage";
import EmailTemplatesView from "@/pages/EmailTemplatesView";
import EmailLogView from "@/pages/EmailLogView";
import ExtraImpostazioniView from "@/pages/ExtraImpostazioniView";
import ExtraStatoCorsiPage from "@/pages/ExtraStatoCorsiPage";
import ComunicatorPage from "@/pages/ComunicatorPage";
import ComMailTemplatesPage from "@/pages/ComMailTemplatesPage";
import ComAllegatiPage from "@/pages/ComAllegatiPage";
import ComLogPage from "@/pages/ComLogPage";
import ExtraListinoPage from "@/pages/ExtraListinoPage";
import ExtraMatricePage from "@/pages/ExtraMatricePage";
import RfMatricePage from "@/pages/RfMatricePage";
import RfRichiestePage from "@/pages/RfRichiestePage";
import AziendaAnagraficaPage from "@/pages/AziendaAnagraficaPage";
import AnalyticsDashboardPage from "@/pages/AnalyticsDashboardPage";
import PrivacyIncaricatiPage from "@/pages/PrivacyIncaricatiPage";
import PrivacyTrattamentiPage from "@/pages/PrivacyTrattamentiPage";
import PrivacyNominePage from "@/pages/PrivacyNominePage";
import PrivacyTabellePage from "@/pages/PrivacyTabellePage";
import PrivacyModelliPage from "@/pages/PrivacyModelliPage";
import PrivacyCorsiPage from "@/pages/PrivacyCorsiPage";
import PrivacyControlliPage from "@/pages/PrivacyControlliPage";
import PrivacyEsterniPage from "@/pages/PrivacyEsterniPage";
import PrivacyAziendaPage from "@/pages/PrivacyAziendaPage";
import PrivacyFascicoloConfigPage from "@/pages/PrivacyFascicoloConfigPage";
import PrivacyFascicoloPage from "@/pages/PrivacyFascicoloPage";
import PublicFascicoloPage from "@/pages/PublicFascicoloPage";
import PublicFascicoloV2Page from "@/pages/PublicFascicoloV2Page";
import SchedaPubblicaPage from "@/pages/SchedaPubblicaPage";
import ConfermaIscrizionePublic from "@/pages/ConfermaIscrizionePublic";
import PrivacyFascicoloDashboardPage from "@/pages/PrivacyFascicoloDashboardPage";
import MensaAuditLogPage from "@/pages/MensaAuditLogPage";
import HomePortal from "@/pages/HomePortal";
import AnnoAttivoSelector from "@/components/AnnoAttivoSelector";
import PendingApprovalPage from "@/pages/PendingApprovalPage";
import RejectedPage from "@/pages/RejectedPage";
import AlunniPortalPage from "@/pages/AlunniPortalPage";
import MensaMesePage from "@/pages/MensaMesePage";
import MensaMesePeriodiPage from "@/pages/MensaMesePeriodiPage";
import AcquistiPlaceholderPage from "@/pages/AcquistiPlaceholderPage";
import AcquistiOrdiniPage from "@/pages/AcquistiOrdiniPage";
import AcquistiProdottiPage from "@/pages/AcquistiProdottiPage";
import AcquistiEmailLogPage from "@/pages/AcquistiEmailLogPage";
import ScuolaListinoPage from "@/pages/ScuolaListinoPage";
import ScuolaCurriculumPage from "@/pages/ScuolaCurriculumPage";
import LibreriaPage from "@/pages/LibreriaPage";
import ScuolaAgevolazioniReportPage from "@/pages/ScuolaAgevolazioniReportPage";
import ComitatoSolidalePage from "@/pages/ComitatoSolidalePage";
import AlunniPortalAccessLogPage from "@/pages/AlunniPortalAccessLogPage";
import SchedaAdminPage from "@/pages/SchedaAdminPage";
import AlunniAccreditatiPage from "@/pages/AlunniAccreditatiPage";
import SegremaWebAlunniGenitori from "@/pages/SegremaWebAlunniGenitori";
import DocumentiCatalogoPage from "@/pages/DocumentiCatalogoPage";
import TabelleConfigPage from "@/pages/TabelleConfigPage";
import RiconciliazioneIncassiPage from "@/pages/RiconciliazioneIncassiPage";
import InsegnantiPublicPage from "@/pages/InsegnantiPublicPage";
import PortineriaPortal, { PortineriaPresenzeRoute, PortineriaCorsiRoute, MensaDocentiGestioneRoute } from "@/pages/PortineriaPortal";
import TabellaCorsiPage from "@/pages/TabellaCorsiPage";
import OpenDayIscrizioniPage from "@/pages/OpenDayIscrizioniPage";
import StampePage from "@/pages/StampePage";
import SituazioniContabiliPage from "@/pages/SituazioniContabiliPage";

// Build tag — incrementare ad ogni modifica significativa per verificare propagazione deploy.
// Importato da @/lib/buildTag (single source of truth, condiviso con HomePortal).

const PAGE_META = {
  dashboard:    { label: "Dashboard",     path: "dashboard",    el: <Dashboard /> },
  alunni:       { label: "Alunni",        path: "alunni",       el: <AlunniPage /> },
  alunni_genitori: { label: "👨‍👩‍👧 Alunni-Genitori", path: "alunni_genitori", el: <SegremaWebAlunniGenitori /> },
  movimenti:    { label: "Movimenti",     path: "movimenti",    el: <MovimentiPage /> },
  prenotazioni_libri: { label: "📚 Prenotaz. Libri", path: "prenotazioni_libri", el: <PrenotazioniLibriPage /> },
  moduli_alunni: { label: "🏅 Idoneità Sportiva", path: "moduli_alunni", el: <ModuliAlunniPage /> },
  deleghe_ritiro: { label: "👥 Deleghe Ritiro", path: "deleghe_ritiro", el: <DelegheRitiroPage /> },
  farmaci_alunni: { label: "💊 TABELLA FARMACI 2025/26", path: "farmaci_alunni", el: <FarmaciAlunniPage /> },
  farmaci_annuale: { label: "💊 SOMMINISTRAZIONE FARMACI", path: "farmaci_annuale", el: <FarmaciAnnualePage /> },
  diete_alunni: { label: "🍴 Diete", path: "diete_alunni", el: <DieteAlunniPage /> },
  isee_alunni: { label: "💰 ISEE", path: "isee_alunni", el: <IseeAlunniPage /> },
  rid_alunni: { label: "🏦 RID / Mandati", path: "rid_alunni", el: <RidAlunniPage /> },
  dote_scuola: { label: "🎓 Dote Scuola", path: "dote_scuola", el: <DoteScuolaPage /> },
  cedole: { label: "📚 Richiesta Cedole", path: "cedole", el: <CedolePage /> },
  tabelle:      { label: "Tabelle",       path: "tabelle",      el: <TabellePage /> },
  elaborazioni: { label: "Elaborazioni",  path: "elaborazioni", el: <ElaborazioneGiornoPage /> },
  elaborazione_periodo: { label: "Elab. Periodo", path: "elaborazione_periodo", el: <ElaborazionePeriodoPage /> },
  elaborazione_cassa:   { label: "Elab. Cassa",   path: "elaborazione_cassa",   el: <ElaborazioneCassaPage /> },
  report_addebiti:      { label: "Scadenzario Addebiti", path: "report_addebiti",    el: <ReportAddebitiPage /> },
  prima_nota:           { label: "📊 Statistiche",      path: "prima_nota",          el: <PrimaNotaPage /> },
  prima_nota_anagrafica:{ label: "🏢 Anagrafica",       path: "prima_nota_anagrafica", el: <PrimaNotaAnagraficaPage /> },
  prima_nota_fatture:   { label: "📒 Prima Nota",       path: "prima_nota_fatture",  el: <PrimaNotaFatturePage /> },
  prima_nota_voci_extra:{ label: "💰 Voci Extra",       path: "prima_nota_voci_extra", el: <PrimaNotaVociExtraPage /> },
  prima_nota_bilancio:  { label: "📊 Bilancio",         path: "prima_nota_bilancio",  el: <PrimaNotaBilancioPage /> },
  prima_nota_bilancio_schema: { label: "📋 Bilancio Schema", path: "prima_nota_bilancio_schema", el: <PrimaNotaBilancioSchemaPage /> },
  prima_nota_tabelle:   { label: "📋 Tabelle",          path: "prima_nota_tabelle",   el: <PrimaNotaTabellePage /> },
  prima_nota_verifica:  { label: "🔍 Verifica Conti",   path: "prima_nota_verifica",  el: <PrimaNotaVerificaPage /> },
  moduli:       { label: "Moduli",        path: "moduli",       el: <ModuliPage /> },
  stati_cassa:  { label: "Stati di Cassa", path: "stati_cassa",  el: <StatiCassaPage /> },
  riconciliazione_incassi: { label: "💶 Gestione Bonifici", path: "riconciliazione_incassi", el: <RiconciliazioneIncassiPage /> },
  banca:        { label: "Banca",          path: "banca",        el: <BancaPage /> },
  mensa_giorno:   { label: "Elabora Mensa Giorno", path: "mensa_giorno",   el: <MensaGiornoPage /> },
  mensa_mese_periodi: { label: "📅 Periodi gestiti", path: "mensa_mese_periodi", el: <MensaMesePeriodiPage /> },
  mensa_mese_alunni: { label: "📅 Mensa Mese",     path: "mensa_mese_alunni", el: <MensaMesePage /> },
  mensa_matrice:  { label: "Matrice Mensa",   path: "mensa_matrice",  el: <MensaMatricePage /> },
  faq:            { label: "FAQ",             path: "faq",            el: <FaqMensaPage /> },
  mensa_plessi_pomeriggio: { label: "🎓 Refettori pomeriggio", path: "mensa_plessi_pomeriggio", el: <MensaMatricePage initialTab="plessi" /> },
  mensa_storico:  { label: "📚 Storico Mensa", path: "mensa_storico",  el: <MensaStoricoPage /> },
  mensa_presenze: { label: "🍽️ Presenze Mensa", path: "mensa_presenze", el: <MensaPresenzePage /> },
  refettori:      { label: "Refettori",       path: "refettori",      el: <RefettoriPage /> },
  extra_corsi:        { label: "📋 Corsi",             path: "extra_corsi",        el: <ExtraCorsiPage /> },
  extra_tabella_corsi:{ label: "🗂 Tabella corsi",     path: "extra_tabella_corsi", el: <TabellaCorsiPage /> },
  extra_iscrizioni:   { label: "Iscrizioni Extra",   path: "extra_iscrizioni",   el: <ExtraIscrizioniPage /> },
  extra_modelli_mail: { label: "✉ Modelli mail",     path: "extra_modelli_mail", el: <EmailTemplatesView /> },
  extra_log_mail:     { label: "📬 Log mail",         path: "extra_log_mail",     el: <EmailLogView /> },
  extra_impostazioni: { label: "⚙ Impostazioni",     path: "extra_impostazioni", el: <ExtraImpostazioniView /> },
  extra_stato_corsi:  { label: "🌳 Stato corsi",     path: "extra_stato_corsi",  el: <ExtraStatoCorsiPage /> },
  comunicator:        { label: "Comunicazioni",      path: "comunicator",        el: <ComunicatorPage /> },
  credito_situazioni: { label: "💳 Situazioni Contabili", path: "credito_situazioni", el: <SituazioniContabiliPage /> },
  com_modelli:        { label: "✉ Modelli Mail",     path: "com_modelli",        el: <ComMailTemplatesPage /> },
  com_allegati:       { label: "📎 Allegati DOCX",   path: "com_allegati",       el: <ComAllegatiPage /> },
  com_log:            { label: "📬 Log Invii",       path: "com_log",            el: <ComLogPage /> },
  extra_listino:      { label: "Listino Corsi",      path: "extra_listino",      el: <ExtraListinoPage /> },
  extra_matrice:      { label: "Matrice",            path: "extra_matrice",      el: <ExtraMatricePage /> },
  mensa_audit_log:    { label: "✉ Log attività",     path: "mensa_audit_log",    el: <MensaAuditLogPage /> },
  rf_matrice:         { label: "Matrice",            path: "rf_matrice",         el: <RfMatricePage /> },
  rf_richieste:       { label: "Richieste Famiglie", path: "rf_richieste",       el: <RfRichiestePage /> },
  azienda_anagrafica:   { label: "Anagrafica Azienda", path: "azienda_anagrafica",   el: <AziendaAnagraficaPage /> },
  analytics_dashboard:  { label: "📊 Analytics",        path: "analytics_dashboard",  el: <AnalyticsDashboardPage /> },
  privacy_incaricati:   { label: "Incaricati",       path: "privacy_incaricati",   el: <PrivacyIncaricatiPage /> },
  privacy_trattamenti:  { label: "Trattamenti",      path: "privacy_trattamenti",  el: <PrivacyTrattamentiPage /> },
  privacy_nomine:       { label: "Nomine",           path: "privacy_nomine",       el: <PrivacyNominePage /> },
  privacy_tabelle:      { label: "Tabelle",          path: "privacy_tabelle",      el: <PrivacyTabellePage /> },
  privacy_modelli:      { label: "Catalogo Docx", path: "privacy_modelli",      el: <PrivacyModelliPage /> },
  privacy_corsi:        { label: "🎓 Corsi",         path: "privacy_corsi",        el: <PrivacyCorsiPage /> },
  privacy_controlli:    { label: "🔍 Controlli",     path: "privacy_controlli",    el: <PrivacyControlliPage /> },
  privacy_esterni:      { label: "Esterni",          path: "privacy_esterni",      el: <PrivacyEsterniPage /> },
  privacy_azienda:      { label: "Azienda",          path: "privacy_azienda",      el: <PrivacyAziendaPage /> },
  privacy_fascicolo_config: { label: "Fascicoli Privacy", path: "privacy_fascicolo_config", el: <PrivacyFascicoloConfigPage /> },
  privacy_fascicolo_dashboard: { label: "📊 Cruscotto Presa Visione", path: "privacy_fascicolo_dashboard", el: <PrivacyFascicoloDashboardPage /> },
  docenti:      { label: "Anagrafica",      path: "docenti",      el: <DocentiPage /> },
  docenti_sicurezza: { label: "🦺 Sicurezza", path: "docenti_sicurezza", el: <DocentiSicurezzaPage /> },
  importazioni: { label: "Importazioni",  path: "importazioni", el: <ImportazioniPage /> },
  impostazioni: { label: "Impostazioni",  path: "impostazioni", el: <ImpostazioniPage /> },
  utenti:       { label: "Utenti",        path: "utenti",       el: <UtentiPage /> },
  alunni_portal_log: { label: "📋 Log Portale Alunni", path: "alunni_portal_log", el: <AlunniPortalAccessLogPage /> },
  alunni_portal_scheda: { label: "🗂 Scheda Alunno", path: "alunni_portal_scheda", el: <SchedaAdminPage /> },
  alunni_accreditati: { label: "🎓 Alunni Accreditati", path: "alunni_accreditati", el: <AlunniAccreditatiPage /> },
  acquisti_fornitori: { label: "🏭 Fornitori", path: "acquisti_fornitori", el: <PrimaNotaAnagraficaPage /> },
  acquisti_ordini:    { label: "📦 Ordini",    path: "acquisti_ordini",    el: <AcquistiOrdiniPage /> },
  acquisti_prodotti:  { label: "🛒 Prodotti",  path: "acquisti_prodotti",  el: <AcquistiProdottiPage /> },
  acquisti_email_log: { label: "📬 Log Email",  path: "acquisti_email_log", el: <AcquistiEmailLogPage /> },
  scuola_listino:     { label: "💰 Listino",    path: "scuola_listino",     el: <ScuolaListinoPage /> },
  scuola_curriculum:  { label: "🎓 Curriculum", path: "scuola_curriculum",  el: <ScuolaCurriculumPage /> },
  classi:             { label: "📚 Settori Classi", path: "classi",         el: <ClassiPage /> },
  libreria:           { label: "📚 Settori Classi Libreria", path: "libreria", el: <LibreriaPage /> },
  scuola_agev_report: { label: "🎓 Report Agev.", path: "scuola_agev_report", el: <ScuolaAgevolazioniReportPage /> },
  scuola_agev_comparatore: { label: "⚖ Comparatore", path: "scuola_agev_comparatore", el: <ScuolaAgevolazioniReportPage initialTab="comparatore" /> },
  comitato_solidale: { label: "🤝 Consuntivo Comitato Solidale", path: "comitato_solidale", el: <ComitatoSolidalePage /> },
  alunni_agev: { label: "💰 Agevolazioni preventivo", path: "alunni_agev", el: <AlunniPage initialAgevFilter="agev" titlePrefix="💰" /> },
  documenti_catalogo: { label: "📂 Doc. Alunni", path: "documenti_catalogo", el: <DocumentiCatalogoPage /> },
  tabelle_personalizzate: { label: "🧩 Tabelle personalizzate", path: "tabelle_personalizzate", el: <TabelleConfigPage /> },
  verifica_anagrafica:{ label: "🔍 Verifica Anagrafica", path: "verifica_anagrafica", el: <VerificaAnagraficaPage /> },
  openday_iscrizioni: { label: "📝 Iscrizioni", path: "openday_iscrizioni", el: <OpenDayIscrizioniPage /> },
  stampe: { label: "🖨️ Stampe", path: "stampe", el: <StampePage /> },
};

// Raggruppamento del menu admin per stare su una sola riga (dropdown).
// Pagine non incluse vengono mostrate come link singoli a fine menu.
const ADMIN_NAV_GROUPS = [
  { key: "anagrafica",  label: "📋 Anagrafica",   pages: ["dashboard", "azienda_anagrafica", "alunni", "alunni_genitori", "scuola_curriculum", "movimenti", "libreria", "alunni_agev", "prenotazioni_libri", "moduli_alunni", "deleghe_ritiro", "isee_alunni", "tabelle_personalizzate", "documenti_catalogo", "docenti", "scuola_listino", "verifica_anagrafica"] },
  { key: "analytics",   label: "",                pages: ["analytics_dashboard"], flat: true },
  { key: "contabilita", label: "💶 Contabilità",  pages: ["movimenti", "tabelle", "elaborazione_periodo", "elaborazione_cassa", "report_addebiti", "stati_cassa", "banca"] },
  { key: "acquisti",    label: "🛒 Acquisti",     pages: ["acquisti_fornitori", "acquisti_ordini", "acquisti_prodotti", "acquisti_email_log"] },
  { key: "servizi",     label: "🍽️ Servizi",      pages: ["mensa_matrice", "mensa_giorno", "mensa_storico", "refettori", "extra_matrice", "extra_corsi", "extra_iscrizioni", "rf_matrice", "rf_richieste", "moduli"] },
  { key: "privacy",     label: "🔒 Privacy",      pages: ["privacy_azienda", "privacy_nomine", "privacy_trattamenti", "privacy_esterni", "privacy_corsi", "privacy_controlli", "privacy_tabelle", "privacy_modelli", "privacy_fascicolo_config", "privacy_fascicolo_dashboard"] },
  { key: "sistema",     label: "⚙ Sistema",       pages: ["impostazioni", "utenti", "alunni_accreditati"], flat: true },
];

function displayUserName(user) {
  if (!user) return "";
  const name = (user.name || user.username || "").trim();
  if (!name) return "";
  // De-duplica parole consecutive identiche (case-insensitive). Caso reale: Google Workspace
  // restituisce a volte given_name e family_name identici → "segrescuole segrescuole".
  const parts = name.split(/\s+/);
  const out = [];
  for (const p of parts) {
    if (!out.length || out[out.length - 1].toLowerCase() !== p.toLowerCase()) {
      out.push(p);
    }
  }
  return out.join(" ");
}

function GestioneLayout() {
  const { gestione } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = location.pathname.split("/").filter(Boolean).pop();
  const { user, loading, hasGestione } = useAuth();
  const [now, setNow] = useState(new Date());
  const [showImportModal, setShowImportModal] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 60000); return () => clearInterval(t); }, []);

  // Poll badge richieste in attesa ogni 60s (solo admin)
  useEffect(() => {
    if (!user || user.role !== "admin") return;
    let stopped = false;
    const fetchCount = async () => {
      try {
        const mod = await import("@/lib/api");
        const res = await mod.default.get("/admin/pending-users/count");
        if (!stopped) setPendingCount(res.data?.count || 0);
      } catch { /* ignore */ }
    };
    fetchCount();
    const t = setInterval(fetchCount, 60000);
    return () => { stopped = true; clearInterval(t); };
  }, [user]);

  // const handleAggiorna = () => setShowImportModal(true);  // disabilitato: bottone Aggiorna rimosso dall'header (richiesta utente 2026-02-16)
  const days = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  const dateStr = `${days[now.getDay()]} ${now.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })} ${now.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}`;

  if (loading) return <div className="sw-loading" style={{ marginTop: 100 }}>Caricamento...</div>;
  if (!user) return <Navigate to="/" replace />;
  if (!hasGestione(gestione)) return <Navigate to="/" replace />;

  const pages = GESTIONE_PAGES[gestione] || [];
  const realPages = pages.filter(p => p !== "---");
  const meta = GESTIONI_META.find(g => g.key === gestione);
  // Default landing: per extra e richieste_famiglie entra direttamente nella tab "principale" (rossa),
  // altrimenti prende la prima.
  const DEFAULT_LANDING = {
    prima_nota: "prima_nota_fatture",
    mensa_mese: "mensa_mese_periodi",
    extra: "extra_iscrizioni",
    richieste_famiglie: "rf_richieste",
    privacy: "privacy_trattamenti",
    cassa: "elaborazione_periodo",
    agevolazioni: "alunni_agev",
    acquisti: "acquisti_ordini",
  };
  const firstPath = DEFAULT_LANDING[gestione] || realPages[0];

  const esciGestione = () => {
    try { sessionStorage.setItem("stay_on_home", "1"); } catch { /* ignore */ }
    navigate("/");
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f0f0" }}>
      <div className="sw-header">
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <button onClick={() => navigate("/")} data-testid="btn-home"
            style={{ background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "4px 12px", borderRadius: 2, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
            ⌂ Home
          </button>
          <div className="sw-logo">canossa<span>HUB</span></div>
          {meta && (
            <div style={{ fontSize: 11, color: "white", borderLeft: "2px solid rgba(255,255,255,0.4)", paddingLeft: 12, letterSpacing: 0.4, fontWeight: 600 }}>
              {meta.label}
            </div>
          )}
        </div>
        <div className="sw-header-info">
          <span>{dateStr}</span>
          <span style={{ fontWeight: 600 }}>Benvenuto, {displayUserName(user)}</span>
          <span data-testid="app-build-tag" title="Build attuale del frontend — utile per verificare la propagazione di un deploy"
            style={{ fontFamily: "monospace", fontSize: 10, padding: "2px 6px", background: "rgba(0,0,0,0.25)", border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.85)", letterSpacing: 0.3 }}>
            {BUILD_TAG}
          </span>
          <button onClick={esciGestione} data-testid="logout-btn" title="Esci dalla gestione" style={{ background: "rgba(255,255,255,0.2)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "4px 12px", borderRadius: 2, cursor: "pointer", fontSize: 12 }}>Esci</button>
        </div>
      </div>
      {gestione !== "stampe" && (
      <nav className="sw-nav" style={{ display: "flex", alignItems: "center" }}>
        {gestione === "admin" ? (
          <AdminNav pages={pages} pendingCount={pendingCount} />
        ) : (
          pages.map((p, idx) => {
            if (p === "---") {
              return (
                <span key={`sep-${idx}`} data-testid={`nav-sep-${idx}`}
                  style={{ display: "inline-block", width: 1, alignSelf: "stretch", background: "rgba(255,255,255,0.35)", margin: "0 8px" }} />
              );
            }
            // Pagine "nascoste" dal menu di una specifica gestione (richiesta utente 2026-02-16):
            // raggiungibili solo da bottoni nelle pagine principali o da shortcut nella Home, non da link di navbar.
            if ((gestione === "segremat" || gestione === "tabelle_alunni") && (p === "documenti_catalogo" || p === "libreria" || p === "tabelle_personalizzate")) return null;
            // 🆕 Giu 2026: "Movimenti" rimosso dal menu Segremat Web Pro, spostato in Home → "Elenchi e Tabelle". La rotta /g/segremat/movimenti resta attiva.
            if (gestione === "segremat" && p === "movimenti") return null;
            // 🆕 "Farmaci" nascosta dal menu Tabelle Fisse (richiesta utente): raggiungibile solo via URL diretto.
            if (gestione === "tabelle_alunni" && p === "farmaci_alunni") return null;
            // Quando sei DENTRO "Tabelle personalizzate", nascondi le 4 vecchie voci dal menu
            // (restano visibili nelle altre pagine di Tabelle Alunni).
            if (gestione === "tabelle_alunni" && currentPage === "tabelle_personalizzate"
                && (p === "moduli_alunni" || p === "deleghe_ritiro" || p === "farmaci_alunni" || p === "diete_alunni" || p === "isee_alunni" || p === "rid_alunni")) return null;
            const isMensaGiorno = p === "mensa_giorno" && gestione === "mensa";
            // 🆕 Giu 2026: tab "Elabora Mensa Giorno" rimossa dal menu Mensa (spostata in Home come prima voce della card MENSA). La rotta resta attiva.
            if (isMensaGiorno) return null;
            const highlight = isMensaGiorno;
            return (
            <NavLink key={p} to={`/g/${gestione}/${p}`} className={({ isActive }) => isActive ? "active" : ""} data-testid={`nav-${p}`}
              style={highlight ? { background: "#c62828", color: "white", fontWeight: 700, borderRadius: 3, margin: "0 4px", marginLeft: "auto" } : undefined}>
              {PAGE_META[p].label}
              {p === "utenti" && pendingCount > 0 && (
                <span data-testid="nav-utenti-badge" style={{ marginLeft: 6, display: "inline-block", background: "#e53935", color: "white", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", lineHeight: "14px" }}>
                  {pendingCount}
                </span>
              )}
            </NavLink>
            );
          })
        )}
        {/* 🆕 Feb 2026: selettore Anno Scolastico spostato dal top header alla nav bar (richiesta utente).
             Nascosto nelle gestioni dove ogni pagina espone già un proprio selettore A.S. nella toolbar
             (evita duplicazione e conflitti). */}
        {!["mensa", "segremat", "tabelle_alunni", "tabelle_personalizzate", "riconciliazione", "extra", "libri_prenotazione", "cedole_prenotazione", "agevolazioni", "analytics", "faq"].includes(gestione) && (
          <span style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center" }}>
            <AnnoAttivoSelector />
          </span>
        )}
      </nav>
      )}
      <div style={{ paddingBottom: 80 }}>
        <Routes>
          {realPages.map(p => (
            <Route key={p} path={p} element={PAGE_META[p].el} />
          ))}
          {gestione === "docenti" && <Route path="eventi/:codice" element={<DocenteEventiPage />} />}
          {gestione === "admin" && <Route path="eventi/:codice" element={<DocenteEventiPage />} />}
          {(gestione === "admin" || gestione === "privacy") && (
            <Route path="privacy/fascicolo/:ambito/:codice" element={<PrivacyFascicoloPage />} />
          )}
          <Route index element={firstPath ? <Navigate to={firstPath} replace /> : <div style={{ padding: 40, textAlign: "center", color: "#888" }}>Nessuna pagina disponibile</div>} />
          <Route path="*" element={firstPath ? <Navigate to={firstPath} replace /> : <Navigate to="/" replace />} />
        </Routes>
      </div>
      {showImportModal && <ImportazioniModal onClose={() => setShowImportModal(false)} />}
    </div>
  );
}

function AdminNav({ pages, pendingCount }) {
  const [open, setOpen] = useState(null); // group key currently open
  const navigate = useNavigate();
  const containerRef = React.useRef(null);

  // Chiudi dropdown su click esterno
  useEffect(() => {
    const onDoc = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(null);
    };
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, []);

  const currentPath = window.location.pathname;
  // 🆕 Giu 2026: "Utenti" rimosso dalla navbar Admin — ora è voce del gruppo AZIENDA in Home (rotta /g/admin/utenti resta attiva).
  const navPages = pages.filter(p => p !== "utenti");
  const adminPagesSet = new Set(navPages.filter(p => p !== "---"));
  // Pagine non incluse in nessun gruppo → mostrate come link semplici dopo i gruppi
  const groupedPagesSet = new Set(ADMIN_NAV_GROUPS.flatMap(g => g.pages));
  const ungrouped = navPages.filter(p => p !== "---" && !groupedPagesSet.has(p));

  return (
    <div ref={containerRef} style={{ display: "flex", alignItems: "center", width: "100%" }}>
      {ADMIN_NAV_GROUPS.map(group => {
        const visiblePages = group.pages.filter(p => adminPagesSet.has(p));
        if (visiblePages.length === 0) return null;

        // Gruppo "flat": mostra le pagine come tab affiancate (no dropdown).
        // Usato per la sezione Sistema (Impostazioni / Utenti / Alunni Accreditati / Log).
        if (group.flat) {
          return visiblePages.map(p => {
            const active = currentPath.endsWith(`/${p}`);
            // 🆕 Feb 2026: bottone Analytics reso evidente accanto ad "Anagrafica"
            if (p === "analytics_dashboard") {
              return (
                <NavLink key={p} to={`/g/admin/${p}`}
                  data-testid={`nav-${p}`}
                  title="Apre la nuova pagina Analytics con grafici pagamenti, agevolazioni, iscrizioni extra, composizione classi"
                  style={{
                    padding: "6px 14px",
                    marginLeft: 6,
                    background: active
                      ? "linear-gradient(135deg,#6a1b9a 0%,#1a237e 100%)"
                      : "linear-gradient(135deg,#1a237e 0%,#6a1b9a 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 800,
                    fontSize: 12,
                    letterSpacing: 0.3,
                    boxShadow: "0 2px 5px rgba(26,35,126,0.35)",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}>
                  📊 Analytics
                </NavLink>
              );
            }
            return (
              <NavLink key={p} to={`/g/admin/${p}`}
                className={active ? "active" : ""}
                data-testid={`nav-${p}`}>
                {PAGE_META[p].label}
                {p === "utenti" && pendingCount > 0 && (
                  <span data-testid="nav-utenti-badge" style={{ marginLeft: 6, display: "inline-block", background: "#e53935", color: "white", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", lineHeight: "14px" }}>
                    {pendingCount}
                  </span>
                )}
              </NavLink>
            );
          });
        }

        const hasActive = visiblePages.some(p => currentPath.endsWith(`/${p}`));
        const isOpen = open === group.key;
        const groupPending = group.pages.includes("utenti") && pendingCount > 0;
        return (
          <div key={group.key} className="sw-nav-group" data-testid={`adminnav-group-${group.key}`}>
            <button type="button" className={`sw-nav-group-btn ${hasActive ? "has-active" : ""}`}
              onClick={(e) => { e.stopPropagation(); setOpen(isOpen ? null : group.key); }}
              data-testid={`adminnav-btn-${group.key}`}>
              {group.label}
              {groupPending && (
                <span data-testid="adminnav-pending-badge" style={{ marginLeft: 4, background: "#e53935", color: "white", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", lineHeight: "14px" }}>
                  {pendingCount}
                </span>
              )}
              <span className="caret">▼</span>
            </button>
            {isOpen && (
              <div className="sw-nav-dropdown" data-testid={`adminnav-dd-${group.key}`}>
                {visiblePages.map(p => {
                  const active = currentPath.endsWith(`/${p}`);
                  return (
                    <a key={p} href={`/g/admin/${p}`} data-testid={`nav-${p}`} className={active ? "active" : ""}
                      onClick={(e) => { e.preventDefault(); setOpen(null); navigate(`/g/admin/${p}`); }}>
                      {PAGE_META[p].label}
                      {p === "utenti" && pendingCount > 0 && (
                        <span data-testid="nav-utenti-badge" style={{ marginLeft: 6, display: "inline-block", background: "#e53935", color: "white", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", lineHeight: "14px" }}>
                          {pendingCount}
                        </span>
                      )}
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
      {ungrouped.map(p => (
        <NavLink key={p} to={`/g/admin/${p}`} className={({ isActive }) => isActive ? "active" : ""} data-testid={`nav-${p}`}>
          {PAGE_META[p].label}
        </NavLink>
      ))}
    </div>
  );
}

function ImportazioniModal({ onClose }) {
  return (
    <div data-testid="importazioni-modal" onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 500, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: 20, overflowY: "auto" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", width: "100%", maxWidth: 1100, marginTop: 20, boxShadow: "0 8px 32px rgba(0,0,0,0.3)", borderRadius: 4, overflow: "hidden" }}>
        <div style={{ background: "#2e7d32", color: "white", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>⟳ Importazioni / Sincronizzazione</div>
          <button data-testid="btn-close-import-modal" onClick={onClose}
            style={{ background: "none", border: "none", color: "white", fontSize: 22, cursor: "pointer", fontWeight: 700 }}>✕</button>
        </div>
        <div style={{ padding: 0 }}>
          <ImportazioniPage />
        </div>
      </div>
    </div>
  );
}

// 🆕 Selector "Anno Scolastico attivo" ora importato da `/components/AnnoAttivoSelector.jsx`
// (spostato in file separato per riuso in HomePortal — feb 2026).

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnnoScolasticoProvider>
          <Routes>
            <Route path="/" element={<HomePortal />} />
            <Route path="/alunni" element={<AlunniPortalPage />} />
            <Route path="/fascicolo" element={<PublicFascicoloPage />} />
            <Route path="/fascicolo/:token" element={<PublicFascicoloV2Page />} />
            <Route path="/scheda/:token" element={<SchedaPubblicaPage />} />
            <Route path="/conferma-iscrizione/:token" element={<ConfermaIscrizionePublic />} />
            <Route path="/insegnanti" element={<InsegnantiPublicPage />} />
            <Route path="/portineria" element={<PortineriaPortal />} />
            <Route path="/portineria/presenze" element={<PortineriaPresenzeRoute />} />
            <Route path="/mensa-docenti" element={<MensaDocentiGestioneRoute />} />
            <Route path="/portineria/corsi" element={<PortineriaCorsiRoute />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/pending" element={<PendingApprovalPage />} />
            <Route path="/rejected" element={<RejectedPage />} />
            <Route path="/g/:gestione/*" element={<GestioneLayout />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnnoScolasticoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
